import router from '../router/index.js'

/**
 * 安全路由跳转方法
 * @param {string} path 目标路径
 * @returns {Promise<boolean>} 跳转是否成功
 */
const safeRouterPush = async (path) => {
  if (router.currentRoute.value.path === path) {
    console.log(`当前已在路径${path}，无需跳转`)
    return false
  }

  try {
    await router.push(path)
    console.log(`路由跳转成功：${path}`)
    return true
  } catch (error) {
    console.error(`路由跳转失败：${path}，错误信息：`, error)
    try {
      await router.replace(path)
      console.log(`路由替换成功：${path}`)
      return true
    } catch (replaceError) {
      console.error(`路由替换也失败：${path}，错误信息：`, replaceError)
      return false
    }
  }
}

/**
 * 全局返回处理函数（核心改进：profile/settings子页返回/profile/，避免返回子页）
 */
export const handleGlobalBack = async (options = {}) => {
  const { targetPath } = options;
  const currentRoute = router.currentRoute.value;
  console.log('当前路由参数:', currentRoute)

  // 【修改】从query中获取_previousRoute（不再从params取）
  const previousRoute = currentRoute.query?._previousRoute || '';
  const previousRouteSegments = previousRoute.split('/').filter(segment => segment.trim());
  const previousLength = previousRouteSegments.length;
  const canGoBack = !!router.options.history.state?.back;

  const curPath = typeof window !== 'undefined' ? window.location.pathname : '';

  // 当前路由路径
  const currentPath = currentRoute.path;
  const currentPathSegments = currentPath.split('/').filter(segment => segment.trim());
  const currentLength = currentPathSegments.length;

  console.log('参数，当前路由路径:', previousRoute, currentPath)

  // 1. 优先处理指定返回页面
  if (targetPath) {
    console.log('有指定返回页面，尝试返回:', targetPath)
    return await safeRouterPush(targetPath)
  } else if (currentPath === '/' && curPath === '/') {
    console.log('当前在根路径，保持不动', router.getRoutes())
    return router.push(currentPath)
  }

  const isSameRoot = previousLength >= 2 && previousRouteSegments[previousLength - 2] === currentPathSegments[currentLength - 1]

  // 历史记录中，存在上一页的返回方式
  if (previousRoute && previousRoute !== currentPath) {
    console.log('存在上一页，返回:', previousRoute)
    return router.back();
  } else if (isSameRoot) {
    console.log('上级路径相同，不返回子级页面', currentPath, previousRoute)
    return router.push(previousRoute);
  } else if (canGoBack) {
    console.log('可以返回上一页，执行返回')
    return router.back();
  }

  // 历史记录中，没有上一页的返回方式
  const profileSettingsSubPathReg = /^\/profile\/settings\/.+$/
  if (profileSettingsSubPathReg.test(currentPath)) {
    console.log('匹配profile/settings子页，返回/profile/')
    return router.back()
  }

  // 3. 处理带id.html结尾的详情页路由
  const detailPathReg = /^\/(notice|sign|recharge|withdraw)\/detail\/(\d+)(\.html)?$/
  const detailPathMatch = currentPath.match(detailPathReg)
  if (detailPathMatch) {
    console.log('匹配到详情页路由，执行浏览器返回')
    return router.back()
  }

  // 4. 有浏览器历史记录则，会跳出当前项目路由，弃用
  // if (window.history.length > 1) {
  //   console.log('浏览器有历史记录，执行原生返回')
  //   router.back()
  //   return
  // }

  // 5. 无历史记录时构建上一级路径（避免指向子页面）
  const pathSegments = currentPath.split('/').filter(segment => segment.trim())
  const pathLevel = pathSegments.length
  let parentPath = '/'

  if (pathLevel >= 2) {
    // 构建上一级路径，且排除子页层级
    parentPath = '/' + pathSegments.slice(0, -1).join('/')
    // 验证路由是否存在
    const routeExists = router.getRoutes().some(route => route.path === parentPath)
    if (!routeExists) parentPath = '/'
  }

  // 6. 模块级逻辑返回兜底
  const moduleRoutes = {
    '/profile/edit': '/profile',
    '/profile/achievements': '/profile',
    '/profile/settings': '/profile',
    '/about/help': '/about',
    '/sign/record': '/sign',
    '/recharge/record': '/recharge',
    '/withdraw/record': '/withdraw',
    '/invite/index': '/index',
    '/invite/list': '/invite',
    '/about/privacy': '/about',
    '/about/agreement': '/about'
  }

  const finalPath = moduleRoutes[currentPath] || parentPath || '/'
  console.log('无历史记录，重定向到:', finalPath)
  return await safeRouterPush(finalPath)
}

/**
 * 全局页面跳转处理函数
 * **/
// export const handleGlobalGoto = async (path) => {
//   return await safeRouterPush(path)
// }
